import React, { Component } from 'react';
import _ from 'lodash';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { Link, withRouter } from 'react-router-dom';
import {isMobile} from 'react-device-detect';

import './stylesheets/DocumentsPage.css';

import { documentNumberFormatter, rowClassNameFormatWithUnread, renderShowsTableTotal } from '../../utils/bootstrapTableFormatters';
import { MergeAttributes } from '../../components/FlatData';
import Loading from '../../components/Loading';
import SimpleModal from '../../components/SimpleModal';
import PositionFilter from '../../components/documents/filters/PositionFilter';
import StatusFilter from '../../components/documents/filters/StatusFilter';

import WorkflowProcessHistory from '../../components/WorkflowProcessHistory';
import Forward from '../../components/WorkflowActions/Forward';
import BatchForwarding from '../../components/BatchForwarding';

import WorkflowProcessStore from '../../stores/WorkflowProcessStore';

class DocumentsPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      isDataFetched: false,
      workflow_processes: [],
      active_position_user_id: '',
      available_statuses: [],
      active_status: '',
      pagination: {},
      searchText: '',
      selectedWorkflowProcessIds: [],
      modal_form: "history",
      modal_title: "ประวัติการดำเนินการ",
      internal_users: [],
      department_groups: [],
      actings: [],
      acting_positions_user_ids: [],
      clicked: false,
      currentForwardIndex: 0
    }
    
    this.stateFormatter = this.stateFormatter.bind(this);
    this.redirectToShowDocumentPage = this.redirectToShowDocumentPage.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleChangePosition = this.handleChangePosition.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.createBatchForwardButton = this.createBatchForwardButton.bind(this);
    this.handleBatchForwardClick = this.handleBatchForwardClick.bind(this);
    this.getUnselectableDocuments = this.getUnselectableDocuments.bind(this);
    this.handleBatchForward = this.handleBatchForward.bind(this);
    this.preventMultiClicks = this.preventMultiClicks.bind(this);
    this.forwardDocument = this.forwardDocument.bind(this);
    this.reloadData = this.reloadData.bind(this);
    this.openFullScreenHistory = this.openFullScreenHistory.bind(this);
  }

  componentDidMount() {
    var self = this;
    this.reloadData();

    setInterval(function(){
      self.reloadData();
    }, 300000)
  }

  reloadData(){
    var self = this;
    this.setState({isDataFetched: false});

    WorkflowProcessStore.request({url: 'workflow_processes?type=inbox&page=1'}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const available_statuses = _.get(resp.data, 'available_statuses', []);
      const internal_users =  _.get(resp.data, 'included.internal_users', []);
      const department_groups =  _.get(resp.data, 'included.department_groups', []);
      const actings = _.get(resp.data, 'included.actings', []);
      const acting_positions_user_ids = _.map(actings, 'attributes.positions_user.id') || [];
      const pagination = _.get(resp.data, 'meta.pagination', {});

      self.setState({
        workflow_processes: workflow_processes,
        available_statuses: available_statuses,
        internal_users: internal_users,
        department_groups: department_groups,
        pagination: pagination
      });
    }).then(()=>{
      self.setState({isDataFetched: true});
    });
  }

  redirectToShowDocumentPage(row, isSelected, e){
    this.props.history.push(`/templates/documents/${row.attributes.document.id}/show/${row.attributes.document_template.id}/wp/${row.id}`);
  }

  stateFormatter(cell, row) {
    return (
      <a href="#" onClick={this.openModal.bind(this, row.id)}>
        {cell}
      </a>
    )
  }

  openModal(workflow_process_id, event){
    event.stopPropagation();

    this.setState({
      open: true,
      modal_form: "history",
      workflow_process_id: workflow_process_id,
    });
  }

  handleChangePosition(pu_id){
    this.setState({isDataFetched: false, workflow_processes: []});

    const { active_status, searchText } = this.state;
    WorkflowProcessStore.request({url: `workflow_processes?type=inbox&positions_user_id=${pu_id}&status=${active_status}&page=1&searchText=${searchText}`}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});
      
      this.setState({
        active_position_user_id: pu_id,
        workflow_processes: workflow_processes,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  handleChangeStatus(status){
    this.setState({isDataFetched: false, workflow_processes: []});

    const { active_position_user_id, searchText } = this.state;
    WorkflowProcessStore.request({url: `workflow_processes?type=inbox&status=${status}&positions_user_id=${active_position_user_id}&page=1&searchText=${searchText}`}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});
      
      this.setState({
        active_status: status,
        workflow_processes: workflow_processes,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  onClose(){
    this.setState({
      open: false,
      workflow_process_id: null
    });
  }

  handlePageChange(page, sizePerPage){
    this.setState({isDataFetched: false, workflow_processes: []});
    const { active_status, active_position_user_id, searchText } = this.state;

    WorkflowProcessStore.request({url: `workflow_processes?type=inbox&status=${active_status}&positions_user_id=${active_position_user_id}&page=${page}&searchText=${searchText}`}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});
      
      this.setState({
        workflow_processes: workflow_processes,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  handleSearchChange(searchText){
    if (searchText.length === 1) { return }
    this.setState({isDataFetched: false, workflow_processes: []});
    const { active_status, active_position_user_id } = this.state;

    WorkflowProcessStore.request({url: `workflow_processes?type=inbox&status=${active_status}&positions_user_id=${active_position_user_id}&page=1&searchText=${searchText}`}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});
      
      this.setState({
        workflow_processes: workflow_processes,
        pagination: pagination,
        searchText: searchText
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  _setTableOption(){ 
    if(this.state.isDataFetched){
      return "ไม่มีข้อมูล";
    }else{
      return <Loading />
    }
  }

   onRowSelect(row, isSelected, e) {
    let selectedWorkflowProcessIds = _.clone(this.state.selectedWorkflowProcessIds)
    let isIncluded = _.includes(selectedWorkflowProcessIds, row.id)

    if (isIncluded){
      selectedWorkflowProcessIds = _.pull(selectedWorkflowProcessIds, row.id)
    }else{
      selectedWorkflowProcessIds = [...selectedWorkflowProcessIds, row.id]
    }
    
    this.setState({selectedWorkflowProcessIds: selectedWorkflowProcessIds})
  }

  createBatchForwardButton(onClick) {
    let hiddenClass = "";

    if(_.isEmpty(this.state.selectedWorkflowProcessIds)){
      hiddenClass = " d-none"
    }

    return (
      <button className={"btn btn-sm btn-success mt-3" + hiddenClass} onClick={ this.handleBatchForwardClick }>ส่งต่อ</button>
    );
  }

  handleBatchForwardClick(){
    this.setState({ 
      modal_form: "forward",
      modal_title: "ส่งต่อ",
      open: true,
    });
  }

  getUnselectableDocuments(documents){
    const unselectable = _.reject(documents, { 'workflow_name': 'workflow_internal_receive', 'current_state_name': 'รอนำเสนอเกษียน' })

    return _.map(unselectable, "id");
  }

  handleBatchForward(targets){
    this.preventMultiClicks();
    
    this.setState({
      modal_form: "batchForward",
      modal_title: "กำลังส่งต่อ",
    }, function(){
      this.forwardDocument(targets);
    });
  }

  forwardDocument(targets){
    let {currentForwardIndex, selectedWorkflowProcessIds} = this.state;
    const workflowProcessId = selectedWorkflowProcessIds[currentForwardIndex];

    if(currentForwardIndex < selectedWorkflowProcessIds.length){

      WorkflowProcessStore.request({
        id: workflowProcessId,
        method: 'put',
        data: {
          action_name: "ส่งต่อ",
          targets: targets
        },
      }).then(()=>{
        this.setState({
          currentForwardIndex: currentForwardIndex + 1
        }, function(){
          this.forwardDocument(targets);
        });
      }, function(error){
        let error_message = _.get(error.response.data, 'error.message', '');
        alert(error_message);
      });

    } else {
      this.setState({
        currentForwardIndex: 0
      }, function(){
        window.location.reload();
      });
    }

  }

  preventMultiClicks(){
    this.setState({clicked: true});

    setTimeout(() => {
      this.setState({clicked: false});
    }, 3000);
  }

  openFullScreenHistory(){
    this.props.history.push(`/full_history/${this.state.workflow_process_id}`);
  }

  render(){
    const total_items_count = _.get(this.state.pagination, 'total_items_count', 0);
    const active_page = _.get(this.state.pagination, 'active_page', 1);
    const options = {
      sizePerPageList: [],
      sizePerPage: 20,
      page: active_page,
      noDataText: this._setTableOption(),
      onRowClick: this.redirectToShowDocumentPage,
      onPageChange: this.handlePageChange,
      onSearchChange: this.handleSearchChange,
      searchDelayTime: 500,
      insertBtn: this.createBatchForwardButton,
      paginationShowsTotal: renderShowsTableTotal
    };

    let data = [];
    if (!_.isEmpty(this.state.workflow_processes)){
      data = MergeAttributes(this.state.workflow_processes);
    }

    let selectRowProp = {
        mode: 'checkbox',
        onSelect: this.onRowSelect,
        selected: this.state.selected,
        unselectable: this.getUnselectableDocuments(data)
    };

    if(isMobile) {
      selectRowProp = {}
    }

    return (
      <div className="inbox">
        <div className='row'>
          <div className='col-7'>
            <h4>เอกสารของฉัน</h4>
          </div>
          <div className='col-5 text-right d-none d-lg-block'>
            <Link to='/templates' className='btn btn-success'>ร่างเอกสาร</Link>
          </div>
        </div>

        <PositionFilter 
          active_position_user_id={this.state.active_position_user_id}
          handleChangePosition={this.handleChangePosition} />

        <StatusFilter 
          available_statuses={this.state.available_statuses}
          active_status={this.state.active_status}
          handleChangeStatus={this.handleChangeStatus} />

        <div className='rui-mydoc'>
          <BootstrapTable 
            data={data}
            remote={ true }
            fetchInfo={{dataTotalSize: total_items_count}}
            search={ true }
            multiColumnSearch={ true }
            selectRow={ selectRowProp }
            options={ options }
            striped
            hover
            pagination
            version='4'
            tableContainerClass={'table-sm'}
            trClassName={rowClassNameFormatWithUnread}
            insertRow>
            <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
            <TableHeaderColumn width="200" dataFormat={documentNumberFormatter}>เลขที่หนังสือ</TableHeaderColumn>
            <TableHeaderColumn dataField='topic' columnTitle dataSort={ true }>เรื่อง</TableHeaderColumn>
            <TableHeaderColumn dataField='from_department' columnTitle dataSort={ true }>จาก</TableHeaderColumn>
            <TableHeaderColumn dataField='to_department' columnTitle dataSort={ true }>เรียน</TableHeaderColumn>
            <TableHeaderColumn dataField='type_name' width='100'>ประเภท</TableHeaderColumn>
            <TableHeaderColumn dataField='current_state_name' dataSort={ true } dataFormat={this.stateFormatter} width='160'>สถานะ</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <SimpleModal 
          isOpen={this.state.open}
          title={this.state.modal_title}
          size={'modal-lg'}
          showSubmitButton={false}
          onClose={this.onClose}>

            {this.state.modal_form === "history" && (
              <div>
                <WorkflowProcessHistory id={this.state.workflow_process_id} />

                <div className="modal-footer row">
                  <button type='button' className="btn btn-primary pointer" onClick={this.openFullScreenHistory}>ดูแบบเต็มหน้าจอ</button>
                  <button type='button' className="btn btn-secondary pointer" onClick={this.onClose}>ปิด</button>
                </div>
              </div>
            )}

            {this.state.modal_form === "forward" && (
              <Forward  internal_users={this.state.internal_users}
                        department_groups={this.state.department_groups}
                        acting_positions_user_ids={this.state.acting_positions_user_ids}
                        actings={this.state.actings}
                        onSubmitAction={this.handleBatchForward}
                        clicked={this.state.clicked}
                        onCloseModal={this.onClose} />
            )}

            {this.state.modal_form === "batchForward" && (
              <BatchForwarding  totalCount={this.state.selectedWorkflowProcessIds.length}/>
            )}
        </SimpleModal>
      </div>
    );
  }
}

export default withRouter(DocumentsPage);


// WEBPACK FOOTER //
// ./src/pages/documents/DocumentsPage.js